import React, { useState, useEffect, useRef } from 'react';
import '../componentCss/webform.css';
import '../componentCss/sidebar.css';
import '../componentCss/userGroup.css';
import '../componentCss/healthcare-modern.css';
import { getUserGroupListAction } from '../../Action/modernAdminActions';
import toast, { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';
import config from '../../config/config';
import DataTable from 'react-data-table-component';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { MdEdit, MdAdd, MdPrint, MdSearch, MdGroup, MdSecurity } from 'react-icons/md';
import { FaUserShield, FaUsers, FaChartLine } from 'react-icons/fa';
import { BsShield, BsSearch } from 'react-icons/bs';
import {decryptData} from './decrypt'
import { Container, Row, Col, Modal, Form, InputGroup } from "react-bootstrap";

const StaffManagement = () => {
    const [userGroupList, setUserGroupList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [formList, setFormList] = useState([]);

    const allDataRef = useRef();
    const singleRowRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const [viewMode, setViewMode] = useState('table'); // 'table' or 'cards'

    const filteredUserGroupList = userGroupList.filter((data) =>
      (data.display_name || data.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (data.description || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (data.code || data.role_id || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handlePageChange = (page) => {
        setCurrentPage(page - 1);
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage)
    };

        useEffect(() => {
        getUserGroupListAPI();
    }, []);

    useEffect(() => {
        setSelectedRow(null);
    }, [currentPage]);

    const getUserGroupListAPI = async () => {
        let res = await getUserGroupListAction();
        setIsLoading(false);
        if (res.success) {
            // Handle both modern (plain data) and legacy (encrypted data) formats
            const data = res.data;
            if (Array.isArray(data)) {
                // Modern format - data is already decrypted
                setUserGroupList(data);
            } else if (typeof data === 'string') {
                // Legacy format - data needs decryption
                setUserGroupList(decryptData(data));
            } else {
                // Fallback - try to use data as-is
                setUserGroupList(data || []);
            }
        }
    };

    
    const columns = [
        {
            name: '#',
            cell: (row, index, column, id) => {
                return index + 1 + currentPage * rowsPerPage;
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Name',
            selector: row => row.display_name || row.name,
            sortable: true,
            width:"20%"
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true,
            width:"45%"
        },
        {
            name: 'Code',
            selector: row => row.code || row.role_id,
            sortable: true,
            width:"10%"
        },
        {
            name: 'Status',
            selector: row => (
                <span className={`healthcare-status-badge ${
                    (row.is_active || row.status === 1) 
                        ? 'healthcare-status-active' 
                        : 'healthcare-status-inactive'
                }`}>
                    {(row.is_active || row.status === 1) ? 'Active' : 'Inactive'}
                </span>
            ),
            sortable: true,
            width:"10%"
        },
        {
            name: 'Actions',
            selector: row => (
                <div className="d-flex gap-2">
                    <Link 
                        to={`${config.baseUrl}edit-user-group/${row.role_id || row.id}`} 
                        title='Edit Role Details'
                        className="healthcare-action-btn healthcare-action-edit"
                    >
                        <MdEdit size={14} />
                        Edit
                    </Link>
                    
                    <Link 
                        to={`${config.baseUrl}rolesPermission`} 
                        title='Manage Role Permissions'
                        className="healthcare-action-btn healthcare-action-permissions"
                        onClick={() => {
                            sessionStorage.setItem('selectedRoleForPermissions', row.role_id || row.id);
                        }}
                    >
                        <BsShield size={14} />
                        Permissions
                    </Link>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width:"30%"
        }
    ];

    const printColumns = [
        {
            name: '#',
            cell: (row, index) => index + 1,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true,
        },
        {
            name: 'Code',
            selector: row => row.code,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status == 1 ? 'Active' : 'Inactive',
            sortable: true,
        }
    ];

    
    const printSingleRow = useReactToPrint({
        content: () => singleRowRef.current,
    });

    const printAllData = useReactToPrint({
        content: () => allDataRef.current,
    });

    useEffect(() => {
        if (selectedRow) {
            printSingleRow();
        }
    }, [selectedRow, printSingleRow]);


    return (
        <>
            {/* <Dashboardheader /> */}
            {/* <ToastContainer /> */}
            {/* <div className="wrapper">
                <Sidebar /> */}
                {/* <div id="content"> */}
                    <Container fluid className="p-4 healthcare-container">
                        <Row>
                            <Col lg={12} md={12} sm={12}>
                                <div className="healthcare-card">
                                    <div className="healthcare-header">
                                        <h5>
                                            <FaUserShield size={24} />
                                            Roles Management
                                        </h5>
                                        <div className="subtitle">
                                            Manage system roles, permissions, and user access levels
                                        </div>
                                    </div>
                                    
                                    <div className="p-4">
                                        <div className="healthcare-table-header">
                                            <div className="d-flex align-items-center gap-3 flex-grow-1">
                                                <div className="healthcare-search-container">
                                                    <BsSearch className="healthcare-search-icon" size={16} />
                                                    <input
                                                        type="text"
                                                        className="healthcare-search-input"
                                                        placeholder="Search roles..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                                <div className="text-muted small">
                                                    {filteredUserGroupList.length} of {userGroupList.length} roles
                                                </div>
                                            </div>
                                            
                                            <div className="healthcare-table-actions">
                                                <Link 
                                                    to={`${config.baseUrl}add-user-group`}  
                                                    title='Add New Role'
                                                    className="healthcare-btn healthcare-btn-primary no-print"
                                                >
                                                    <MdAdd size={16} />
                                                    Add New Role
                                                </Link>
                                                <ReactToPrint
                                                    trigger={() => 
                                                        <button 
                                                            title='Print' 
                                                            className='healthcare-btn healthcare-btn-secondary no-print'
                                                        >
                                                            <MdPrint size={16} />
                                                            Print
                                                        </button>
                                                    }
                                                    content={printAllData}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mt-4">
                                <div className='healthcare-table-container'>
                                    {isLoading ? (
                                        <div className="healthcare-loading">
                                            <div className="healthcare-loading-spinner"></div>
                                            <div className="healthcare-loading-text">Loading roles...</div>
                                        </div>
                                    ) : (
                                        <DataTable
                                            columns={columns}
                                            data={filteredUserGroupList}
                                            pagination
                                            paginationPerPage={rowsPerPage}
                                            paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
                                            paginationComponentOptions={{
                                                rowsPerPageText: 'Rows per page:',
                                                rangeSeparatorText: 'of',
                                            }}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleRowsPerPageChange}
                                            noDataComponent={
                                                <div className="healthcare-loading">
                                                    <FaUsers size={48} className="text-muted mb-3" />
                                                    <div className="healthcare-loading-text text-muted">
                                                        {searchTerm ? 'No roles found matching your search' : 'No roles available'}
                                                    </div>
                                                    {!searchTerm && (
                                                        <Link 
                                                            to={`${config.baseUrl}add-user-group`}
                                                            className="healthcare-btn healthcare-btn-primary mt-3"
                                                        >
                                                            <MdAdd size={16} />
                                                            Create First Role
                                                        </Link>
                                                    )}
                                                </div>
                                            }
                                        />
                                    )}
                                </div>

                                {/*------------------------------- Section For Showing Single Print--------------------------------------------------- */}
                                <div style={{ display: 'none' }}>
                                    <div className="container mt-5" ref={singleRowRef}>
                                        {selectedRow && (
                                            <div className="card shadow-sm">
                                                <div className="card-body">
                                                    <h2 className="card-title text-center mb-4">Role Details</h2>
                                                    <div className="list-group">
                                                        <div className="list-group-item">
                                                            <strong>ID:</strong> {selectedRow.id}
                                                        </div>
                                                        <div className="list-group-item">
                                                            <strong>Name:</strong> {selectedRow.name}
                                                        </div>
                                                        <div className="list-group-item">
                                                            <strong>Description:</strong> {selectedRow.description}
                                                        </div>
                                                        <div className="list-group-item">
                                                            <strong>Code:</strong> {selectedRow.code}
                                                        </div>
                                                        <div className="list-group-item">
                                                            <strong>Status:</strong> {selectedRow.status == 1 ? 'Active' : 'Inactive'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/*------------------------------- Section For Showing All Data For Print--------------------------------------------------- */}

                                <div style={{ display: 'none' }}>
                                    <div ref={allDataRef}>
                                        <img src="assets/images/logo.png" alt="logo" className='mainLogo' />
                                        <center>
                                            <h2 className=''> Group List</h2>
                                        </center>
                                        <DataTable
                                            columns={printColumns}
                                            data={userGroupList}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>


                  

                {/* </div> */}
            {/* </div> */}
        </>
    );
}

export default StaffManagement;